
import {NgModule} from "@angular/core";

import {RouterModule, Routes} from "@angular/router";
import {GLOBAL_CONSTANTS} from "../global/global.constants";
import {LandingComponent} from "./landing/landing.component";
import {RulesComponent} from "./rules.component";
import {SlidesComponent} from "./landing/slides/slides.component";
import {RulesListComponent} from "./rules-list/rules-list.component";
import {RuleDetailsComponent} from "./rule-details/rule-details.component";
import {NewRuleComponent} from "./new-rule/new-rule.component";
import {SelectChannelsComponent} from "./new-rule/select-channels/select-channels.component";
import {RuleBuilderComponent} from "./new-rule/rule-builder/rule-builder.component";
import {SaveRuleComponent} from "./new-rule/save-rule/save-rule.component";
import {SetupActionComponent} from "./new-rule/setup-action/setup-action.component";
import {Constants} from "./constants";
import {RuleEditGuard} from './guards/rule-edit-guard.guard';
import {RuleResolverService} from './resolver/rule-resolver.service';

const routes: Routes = [
  {
    path: '',
    component: RulesComponent,
    canActivateChild: [RuleEditGuard],
    children: [
      {
        path: '',
        component: LandingComponent,
        resolve: {
          rule: RuleResolverService
        },
        data: {
          title: Constants.RULE_LIST_PAGE_TITLE
        },
      },
      { path: 'list',
        component: RulesListComponent ,
        resolve: {

        },
        data: {
          title: Constants.RULE_LIST_PAGE_TITLE
        }
      },
      { path: ':id',
        component: RuleDetailsComponent ,
        resolve: {

        },
        data: {
          title: Constants.RULE_LIST_PAGE_TITLE
        }
      },
      { path: 'new/step-1',
        component: NewRuleComponent ,
        resolve: {

        },
        data: {
          title: Constants.RULE_LIST_PAGE_TITLE
        }
      },
      { path: ':ruleAppliesTo/:id/step-2',
        component: RuleBuilderComponent ,
        resolve: {
        },
        data: {
          title: Constants.RULE_LIST_PAGE_TITLE
        }
      },
      { path: ':id/step-3',
        component: SelectChannelsComponent ,
        resolve: {
        },
        data: {
          title: Constants.RULE_LIST_PAGE_TITLE
        }
      },
      { path: ':id/step-4',
        component: SetupActionComponent ,
        resolve: {
        },
        data: {
          title:Constants.RULE_LIST_PAGE_TITLE
        }
      },
      { path: ':id/step-5',
        component: SaveRuleComponent ,
        resolve: {

        },
        data: {
          title: Constants.RULE_LIST_PAGE_TITLE
        }
      },
      { path: ':ruleId/edit/step-2',
        component: RuleBuilderComponent ,
        data: {
          title: Constants.RULE_LIST_PAGE_TITLE
        },

      },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],
  providers: [RuleResolverService
  ],
})
export class RulesRoutingModule { }

export  let ROUTED_COMPONENT = [LandingComponent, SlidesComponent];



// WEBPACK FOOTER //
// ./src/app/rules/rules.routing.module.ts